export default "__VITE_ASSET__JB3CoPbb__"